<template>
  <div class="register-results-view">
    <div
      v-if="isLoading"
      class="loading"
    >
      <unc-loader />
    </div>

    <div
      v-else
      class="register-card"
    >
      <div class="register-glow" />

      <template v-if="!users">
        <div class="card-header ch-alt register-header">
          <div
            v-if="nextStep === 'LOGIN'"
            class="register-kicker rr-kicker--success"
          >
            <svg
              aria-hidden="true"
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2.5"
                d="M5 13l4 4L19 7"
              />
            </svg>
            Usuario UNC existente
          </div>
          <div
            v-else-if="nextStep === 'RESEND_EMAIL'"
            class="register-kicker rr-kicker--warning"
          >
            <svg
              aria-hidden="true"
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
              />
            </svg>
            Registro en curso
          </div>
          <div
            v-else-if="nextStep === 'CONTACT_ADMIN'"
            class="register-kicker rr-kicker--danger"
          >
            <svg
              aria-hidden="true"
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
            Usuario UNC suspendido
          </div>
          <h1 class="register-title">
            <template v-if="nextStep === 'LOGIN'">
              Ya tenés tu Usuario UNC
            </template>
            <template v-else-if="nextStep === 'RESEND_EMAIL'">
              Registro iniciado anteriormente
            </template>
            <template v-else-if="nextStep === 'CONTACT_ADMIN'">
              Usuario UNC temporalmente suspendido
            </template>
          </h1>
        </div>

        <div class="card-body register-body">
          <div
            v-if="nextStep === 'LOGIN'"
            class="rr-status-block rr-status-block--success"
          >
            <div class="rr-status-icon">
              <svg
                aria-hidden="true"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.8"
                  d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                />
              </svg>
            </div>
            <div class="rr-status-content">
              <p>
                Ya existe registrado un Usuario UNC con el documento <strong>{{ searchIdentifier.code.split('_')[1] }}
                  {{
                    searchIdentifier.number }}</strong>.
              </p>
              <p>
                <span v-if="urlProfile != ''">Presioná el botón "Ir a MiUNC" para iniciar sesión y habilitar tus
                  aplicaciones.</span> Si no recordás tu Usuario UNC, podés comunicarte con el <a
                  href="/contactos"
                  class="register-text-link"
                  target="_blank"
                  rel="noopener"
                >administrador de tu dependencia o facultad<span class="visually-hidden"> (se abre en una pestaña nueva)</span></a>.
              </p>
            </div>
          </div>

          <div
            v-else-if="nextStep === 'RESEND_EMAIL'"
            class="rr-status-block rr-status-block--warning"
          >
            <div class="rr-status-icon">
              <svg
                aria-hidden="true"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.8"
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
            </div>
            <div class="rr-status-content">
              <p>
                Ya iniciaste el registro para crear tu Usuario UNC con el documento <strong>{{
                  searchIdentifier.code.split('_')[1] }} {{ searchIdentifier.number }}</strong>.
              </p>
              <p>Si aún no recibiste el correo para continuar el proceso, a continuación podrás reenviártelo.</p>
              <p>
                Si tenés alguna duda, enviá un correo al <a
                  href="/contactos"
                  class="register-text-link"
                  target="_blank"
                  rel="noopener"
                >administrador de tu dependencia o facultad<span class="visually-hidden"> (se abre en una pestaña nueva)</span></a>.
              </p>
            </div>
          </div>

          <div
            v-else-if="nextStep === 'CONTACT_ADMIN'"
            class="rr-status-block rr-status-block--danger"
          >
            <div class="rr-status-icon">
              <svg
                aria-hidden="true"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.8"
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            </div>
            <div class="rr-status-content">
              <p>
                El Usuario UNC cuyo documento es <strong>{{ searchIdentifier.code.split('_')[1] }} {{
                  searchIdentifier.number
                }}</strong> se encuentra temporalmente <strong>suspendido</strong>.
              </p>
              <p>
                Para solucionar esta situación, comunicate con el <a
                  href="/contactos"
                  class="register-text-link"
                  target="_blank"
                  rel="noopener"
                >administrador de tu dependencia o facultad<span class="visually-hidden"> (se abre en una pestaña nueva)</span></a>.
              </p>
            </div>
          </div>

          <div class="rr-actions">
            <button
              type="button"
              class="btn btn-link waves-effect register-btn register-btn-secondary"
              @click="goBack()"
            >
              Volver
            </button>
            <button
              v-if="nextStep === 'LOGIN'"
              type="button"
              class="btn btn-primary waves-effect register-btn register-btn-primary"
              @click="goProfile()"
            >
              <span>Ir a MiUNC</span>
              <svg
                aria-hidden="true"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
                <polyline points="10 17 15 12 10 7" />
                <line
                  x1="15"
                  y1="12"
                  x2="3"
                  y2="12"
                />
              </svg>
            </button>
            <button
              v-else-if="nextStep === 'RESEND_EMAIL'"
              type="button"
              class="btn btn-primary waves-effect register-btn register-btn-primary"
              @click="reSendEmail()"
            >
              <span>Reenviar correo</span>
              <svg
                aria-hidden="true"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" />
                <polyline points="22,6 12,13 2,6" />
              </svg>
            </button>
          </div>
        </div>
      </template>

      <template v-else-if="users.length >= 1">
        <div class="card-header ch-alt register-header">
          <div class="register-kicker rr-kicker--info">
            {{ users.length === 1 ? 'Una coincidencia encontrada' : `${users.length} coincidencias encontradas` }}
          </div>
          <h1
            id="personas-title"
            class="register-title"
          >
            Encontramos datos
          </h1>
          <p class="register-subtitle">
            Seleccioná la opción que te identifique.
          </p>
        </div>
        <div class="card-body register-body">
          <div
            class="rr-person-list"
            role="radiogroup"
            aria-labelledby="personas-title"
          >
            <label
              v-for="(item, index) of users"
              :key="index"
              class="rr-person-card"
              :class="{ 'is-selected': selectedPerson === item }"
            >
              <input
                v-model="selectedPerson"
                type="radio"
                name="person"
                :value="item"
                class="rr-person-radio"
              >
              <div class="rr-person-avatar">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.9"
                    d="M20 21a8 8 0 00-16 0m12-13a4 4 0 11-8 0 4 4 0 018 0z"
                  />
                </svg>
              </div>
              <div class="rr-person-info">
                <span class="rr-person-name">{{ titleCase(item.names) }} {{ titleCase(item.lastNames) }}</span>
                <span
                  v-if="item.identities.length > 0"
                  class="rr-person-doc"
                >{{ getIdentityText(item) }}</span>
              </div>
              <div class="rr-person-check">
                <svg
                  aria-hidden="true"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2.5"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
            </label>
          </div>

          <p class="rr-hint">
            En caso de no figurar en el listado enviá un correo al <a
              href="/contactos"
              target="_blank"
              class="register-text-link"
              rel="noopener"
            >administrador de tu dependencia o facultad<span class="visually-hidden"> (se abre en una pestaña nueva)</span></a>.
          </p>

          <div class="rr-actions">
            <button
              type="button"
              class="btn btn-link waves-effect register-btn register-btn-secondary"
              @click.prevent="goBack()"
            >
              Volver
            </button>
            <button
              type="button"
              class="btn btn-primary waves-effect register-btn register-btn-primary"
              @click.prevent="goNext()"
            >
              <span>Siguiente</span>
              <svg
                aria-hidden="true"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                />
              </svg>
            </button>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { HttpFRONT, swal } from '../../share.js';
import { titleCase } from '../../utils/titleCase';
import withoutSpaces from '../../../utils/withoutSpaces';

const RESEND_EMAIL_ERROR_MESSAGES = {
    'La persona no tiene el correo de recuperación definido.': 'No pudimos reenviar el correo porque esta cuenta no tiene un email disponible para continuar el registro. Comunicate con el administrador de tu dependencia o facultad.',
    'La persona no esta en un estado valido para realizar la operacion': 'No pudimos reenviar el correo en este momento. Si el problema continúa, comunicate con el administrador de tu dependencia o facultad.',
};

export default {
    name: 'RegisterSearchResults',
    data () {
        return {
            selectedPerson: '',
            urlProfile: '',
            isLoading: false,
        };
    },
    computed: {
        ...mapState(['searchIdentifier']),
        ...mapGetters([
            'users',
            'nextStep',
            'configApp',
            'sharedComponentsInfo',
        ]),
    },
    mounted () {
        if (this.users?.length === 0) {
            this.goRegisterPerson();
        }

        if (this.sharedComponentsInfo && this.sharedComponentsInfo.currentUser) {
            this.selectedPerson = this.sharedComponentsInfo.currentUser;
        }
    },
    methods: {
        titleCase (str) {
            return titleCase(str);
        },
        getIdentity (person) {
            const searchNumber = withoutSpaces(this.searchIdentifier.number);
            const sameNumber = i => withoutSpaces(i.identityNumber) === searchNumber;
            return person.identities.find(i => i.identityType === this.searchIdentifier.code && sameNumber(i)) ||
                person.identities.find(sameNumber) ||
                person.identities[0];
        },
        getIdentityText (person) {
            const identity = this.getIdentity(person);
            return `${identity.identityType.split('_')[1]} ${identity.identityNumber}`;
        },
        goNext () {
            if (!this.selectedPerson) {
                swal({
                    title: 'Debés seleccionar una opción para continuar.',
                    html: 'Si no encontrás tu nombre en el listado, por favor comunicate con el <a href="/contactos" target="_blank" rel="noopener" class="register-text-link">administrador de tu dependencia o facultad<span class="visually-hidden"> (se abre en una pestaña nueva)</span></a>.',
                    type: 'warning',
                });
                return;
            }
            this.$store.commit('setCurrentUser', this.selectedPerson);
            this.$store.commit('setCurrentComponent', 'register-person-rol');
            this.$store.commit('setCurrentUserIdentity', this.getIdentity(this.selectedPerson));
        },
        goRegisterPerson () {
            this.$store.dispatch('cleanCurrentUser');
            this.$store.commit('setCurrentComponent', 'register-person-rol');
        },
        goProfile () {
            window.open(this.configApp.urlProfile, '_blank');
        },
        getResendEmailErrorMessage (message) {
            return RESEND_EMAIL_ERROR_MESSAGES[message] || 'Servicio temporalmente no disponible.';
        },
        async reSendEmail () {
            try {
                this.isLoading = true;
                const response = await HttpFRONT.post('/personas/reSendEmail', {
                    identityType: this.searchIdentifier.code,
                    identityNumber: this.searchIdentifier.number,
                });
                if (response.status === 201 || response.status === 200) {
                    swal({ title: `Correo reenviado a ${response.data.email}`, text: 'Revisá tu correo para continuar con el proceso de creación de tu Usuario UNC. ', type: 'success' });
                    this.$router.push('/');
                }
            } catch (error) {
                const status = error?.response?.status;
                const message = error?.response?.data;
                switch (status) {
                case 401:
                    swal({ title: 'Acceso denegado', text: 'No posee permisos para acceder a este servicio.', type: 'warning' });
                    break;
                case 409:
                    swal({ title: 'No pudimos reenviar el correo', text: this.getResendEmailErrorMessage(message), type: 'warning' });
                    break;
                default:
                    swal({ title: 'Algo salió mal', text: 'Servicio temporalmente no disponible.', type: 'warning' });
                    break;
                }
            } finally {
                this.isLoading = false;
            }
        },
        goBack () {
            this.$store.commit('setCurrentComponent', 'register-search');
        },
    },
};
</script>

<style lang="scss" scoped>
@import './register-shared.scss';

.register-results-view {
  --register-azul: #003865;
  --register-azul-deep: #001f3f;
  --register-azul-mid: #0a5f96;
  --register-verde: #3eb6b8;
  --register-ink: #102238;
  --register-muted: #526579;
  --register-border: rgba(0, 56, 101, 0.14);

  position: relative;
  padding: 0;
}

.rr-kicker--success {
  border-color: rgba(16, 160, 90, 0.25) !important;
  background: rgba(16, 160, 90, 0.1) !important;
  color: #0f7a46 !important;
  gap: 6px;
  display: inline-flex;
  align-items: center;
}

.rr-kicker--warning {
  border-color: rgba(184, 108, 0, 0.25) !important;
  background: rgba(184, 108, 0, 0.1) !important;
  color: #8a5200 !important;
  gap: 6px;
  display: inline-flex;
  align-items: center;
}

.rr-kicker--danger {
  border-color: rgba(200, 50, 70, 0.25) !important;
  background: rgba(200, 50, 70, 0.1) !important;
  color: #a01e34 !important;
  gap: 6px;
  display: inline-flex;
  align-items: center;
}

.rr-kicker--info {
  gap: 6px;
  display: inline-flex;
  align-items: center;
}

.rr-status-block {
  display: flex;
  gap: 20px;
  align-items: flex-start;
  padding: 20px 22px;
  border-radius: 14px;
  margin-bottom: 18px;
  border: 1px solid transparent;
}

.rr-status-block--success {
  background: rgba(16, 160, 90, 0.07);
  border-color: rgba(16, 160, 90, 0.18);
}

.rr-status-block--success .rr-status-icon {
  color: #10a05a;
  background: rgba(16, 160, 90, 0.12);
}

.rr-status-block--warning {
  background: rgba(184, 108, 0, 0.07);
  border-color: rgba(184, 108, 0, 0.18);
}

.rr-status-block--warning .rr-status-icon {
  color: #b86c00;
  background: rgba(184, 108, 0, 0.12);
}

.rr-status-block--danger {
  background: rgba(200, 50, 70, 0.06);
  border-color: rgba(200, 50, 70, 0.18);
}

.rr-status-block--danger .rr-status-icon {
  color: #c03248;
  background: rgba(200, 50, 70, 0.1);
}

.rr-status-block--info {
  background: rgba(10, 95, 150, 0.06);
  border-color: rgba(10, 95, 150, 0.16);
}

.rr-status-block--info .rr-status-icon {
  color: var(--register-azul-mid);
  background: rgba(10, 95, 150, 0.1);
}

.rr-status-icon {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rr-status-icon svg {
  width: 22px;
  height: 22px;
}

.rr-status-content p {
  font-family: var(--font-body);
  font-size: 15px;
  color: var(--register-ink);
  line-height: 1.75;
  margin: 0 0 10px;
}

.rr-status-content p:last-child {
  margin-bottom: 0;
}

.rr-status-content strong {
  font-weight: 700;
  color: var(--register-azul-deep);
}

.rr-intro {
  font-family: var(--font-body);
  font-size: 15px;
  color: var(--register-muted);
  line-height: 1.75;
  margin-bottom: 20px;
}

.rr-intro strong {
  font-weight: 700;
  color: var(--register-azul-deep);
}

.rr-person-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 16px;
}

.rr-person-radio {
  position: absolute;
  opacity: 0;
  pointer-events: none;
  width: 0;
  height: 0;
}

.rr-person-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px 10px;
  border-radius: 14px;
  border: 1.5px solid rgba(0, 56, 101, 0.12);
  background: #ffffff;
  cursor: pointer;
  transition: border-color 0.22s ease, box-shadow 0.22s ease, background-color 0.22s ease, transform 0.22s ease;
  position: relative;
  overflow: hidden;
}

.rr-person-card::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: linear-gradient(to bottom, var(--register-azul), var(--register-verde));
  transform: scaleY(0);
  transform-origin: bottom;
  transition: transform 0.25s ease;
  border-radius: 0 2px 2px 0;
}

.rr-person-card:hover {
  border-color: rgba(62, 182, 184, 0.4);
  box-shadow: 0 4px 16px rgba(0, 56, 101, 0.1);
  transform: translateY(-1px);
}

.rr-person-card.is-selected {
  border-color: rgba(62, 182, 184, 0.7);
  background: linear-gradient(135deg, rgba(62, 182, 184, 0.06), rgba(0, 56, 101, 0.04));
  box-shadow: 0 8px 24px rgba(62, 182, 184, 0.18);
}

.rr-person-card.is-selected::before {
  transform: scaleY(1);
}

.rr-person-avatar {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: linear-gradient(135deg, var(--register-azul), var(--register-azul-mid));
  color: #ffffff;
  font-family: var(--font-display);
  font-size: 18px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background 0.22s ease;
}

.rr-person-avatar svg {
  width: 22px;
  height: 22px;
  color: currentColor;
  stroke: currentColor;
}

.rr-person-card.is-selected .rr-person-avatar {
  background: linear-gradient(135deg, var(--register-azul-mid), var(--register-verde));
}

.rr-person-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.rr-person-name {
  font-family: var(--font-body);
  font-size: 16px;
  font-weight: 600;
  color: var(--register-ink);
}

.rr-person-doc {
  font-family: var(--font-body);
  font-size: 13px;
  font-weight: 500;
  color: var(--register-muted);
  letter-spacing: 0.3px;
}

.rr-person-check {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 2px solid rgba(0, 56, 101, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.22s ease;
  background: transparent;
}

.rr-person-check svg {
  width: 13px;
  height: 13px;
  color: transparent;
  transition: color 0.2s ease;
}

.rr-person-card.is-selected .rr-person-check {
  background: var(--register-verde);
  border-color: var(--register-verde);
}

.rr-person-card.is-selected .rr-person-check svg {
  color: white;
}

.rr-hint {
  font-family: var(--font-body);
  font-size: 14px;
  color: var(--register-muted);
  line-height: 1.7;
  margin-bottom: 18px;
}

.rr-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.register-results-view .register-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

@media (max-width: 991px) {
  .rr-status-block {
    flex-direction: column;
    gap: 14px;
  }

  .rr-actions {
    justify-content: stretch;
    flex-direction: column-reverse;
    gap: 8px;
  }

  .rr-actions .register-btn {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .rr-person-card {
    padding: 14px;
    gap: 12px;
  }

  .rr-person-avatar {
    width: 36px;
    height: 36px;
  }

  .rr-person-avatar svg {
    width: 18px;
    height: 18px;
  }
}
</style>
